module.exports = [
  'Promise',
  function (Promise) {
    return {
      getSignatures: Promise.wrapper('user:getSignatures'),
      updateSignatures: Promise.wrapper('user:updateSignatures')
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/setting/signature/signatureService.js